import { render, staticRenderFns } from "./client-orders.vue?vue&type=template&id=8b8d16a4&"
import script from "./client-orders.vue?vue&type=script&lang=js&"
export * from "./client-orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports